<template>
  <div class="detailPage">
    <div class="titleBox">
      <p class="title">基本信息</p>
      <el-button type="primary" size="mini" @click="updateSmtOrder"
      >修改</el-button>
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">SMT工单：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.orderNumber">{{
            orderDetailData.orderNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customer">{{
            orderDetailData.customer.name
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">物料编码：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.itemCode }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">产品型号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.product">{{
            orderDetailData.product.code
          }}</span>
          <span v-else>-</span>
          <span class="allowSkip" v-if="orderDetailData.product && orderDetailData.product.id=='104481952309051392'"
            @click="switchToD803(orderDetailData.id, 'SN')">&nbsp;&nbsp;切换【智能穿戴】</span>
        </div>
      </li>
      <li>
        <div class="left">Flash固件版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.firmware">
            {{ orderDetailData.firmware.version }}
          </span>
          <span class="value" v-else>
            -
          </span>
        </div>
      </li>
      <li>
        <div class="left">备注：</div>
        <div class="right">
          <span class="value">{{ orderDetailData.notes || '-' }}</span>
        </div>
      </li>
      <li>
        <div class="left">工单数量：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.quantity }} PCS</span>
        </div>
      </li>
      <li>
        <div class="left">已测试数量：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.testQuantity }} PCS</span>
        </div>
      </li>
      <li>
        <div class="left">释放SN数量：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.snReleased }} PCS</span>
        </div>
      </li>
      <li>
        <div class="left">直通率：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.rty }}</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" class="title">扩展字段信息</p>
      <p v-else class="title">投料规则</p>
      <el-button type="primary" size="mini" @click="addOrderExtendInfo"
        >新增</el-button
      >
    </div>
    <ul class="ulBox clearFloat" style="padding-top: 5px;">
      <li class="blockLi">
        <div class="right">
          <el-table
              class="myProductionOrder"
              stripe
              :data="productionOrderExtendData"
              border
              style="width: 100%"
              size="mini"
          >
            <el-table-column label="配件名称"
                             prop="fieldName" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldName">
                  {{scope.row.fieldName}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="物料编码"
                             prop="fieldKey" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldKey">{{ scope.row.fieldKey }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值' : '校验规则'"
                             prop="fieldValue" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldValue">{{ scope.row.fieldValue }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             class-name="operation" align="center" width="100px">
              <template slot-scope="scope">
                <el-tooltip
                    class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                  <i v-if="scope.row.fieldKey" class="el-icon-edit" @click="updateOrderExtendInfo($event, scope.row)"></i>
                </el-tooltip>
                <el-tooltip
                            class="item" effect="dark" content="删除" placement="top" :open-delay="300">
                  <i v-if="scope.row.fieldKey" class="el-icon-delete" @click="deleteOrderExtendInfo($event, scope.row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
    <myDialog ref="myDialog" :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose" width="450px">
      <template slot="content">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="120px">
          <div v-if="dialogTitle === '修改工单信息'">
            <el-form-item label="客户" prop="customerId">
              <el-select v-model="dialogForm.customerId" placeholder="请选择客户" filterable clearable allow-create>
                <el-option v-for="(item, index) in pullDownData.customerList"
                           :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品型号" prop="productId">
              <el-select v-model="dialogForm.productId" placeholder="请选择产品型号" filterable clearable allow-create @change="productChange">
                <el-option v-for="(item, index) in pullDownData.productList"
                    :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Flash固件：" size="small" prop="fwVersion">
              <el-select v-model="dialogForm.fwVersion"
                         placeholder="Flash固件版本" filterable clearable default-first-option>
                <el-option v-for="(item, index) in pullDownData.fwList"
                           :key="item.version + '_' + index" :label="item.customer? (item.version+'('+item.customer.name+')') : item.version" :value="item.version">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" size="small">
              <el-input v-model="dialogForm.notes" placeholder="备注" clearable></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle === '新增扩展字段信息'" key="addProductionOrderExtend">
            <el-form-item label="配件名称：" size="small" prop="fieldName">
              <el-input
                  v-model="dialogForm.fieldName"
                  placeholder="如：LCD_SN"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="物料编码：" size="small" prop="fieldKey">
              <el-input
                  v-model="dialogForm.fieldKey"
                  placeholder="如填写LCD料号：'177010M0013566'"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值：' : '校验规则'" size="small" prop="fieldValue">
              <el-input type="textarea" :rows="5"
                        v-model="dialogForm.fieldValue"
                        placeholder='[{"start":"S13010A4", "len":16}, {"start":"SY130", "len":16},{"start":"LCD25", "len":16}]'
                        clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle === '修改扩展字段信息'" key="updateProductionOrderExtend">
            <el-form-item label="TYPE：" size="small" prop="fieldName">
              <el-input
                  v-model="dialogForm.fieldName"
                  placeholder="如：4G版本号"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="KEY：" size="small" prop="fieldKey">
              <el-input v-model="dialogForm.fieldKey" placeholder="如：4G_version" clearable></el-input>
            </el-form-item>
            <el-form-item :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值：' : '校验规则'" size="small" prop="fieldValue">
              <el-input type="textarea"
                        :autosize="{minRows: 5, maxRows: 20}"
                        v-model="dialogForm.fieldValue"
                        placeholder="JSON字符串"
                        clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>
<script>
import {
  apiSmtOrderDetail,apiSwitchToD803,apiupdateSmtOrder,
} from "@/api/SmtOrder.js";
import {apiFirmwareList} from "@/api/firmwareManage";
import myDialog from "@/components/myDialog.vue";
import {apiProductList} from "@/api/commands";
import {
  apiSearchOrderExtendConfig,apiAddOrderExtendConfig,
  apiUpdateOrderExtendConfig,apiDeleteOrderExtendConfig
} from "@/api/OrderExtendConfig";
import {
  apiCustomerList,
} from "@/api/productionOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  components: {
    myDialog,
  },
  data() {
    return {
      isDataLoaded : false,
      pullDownData: {
        customerList: [],
        productList: [],
        fwList: [],
      },
      productionOrderExtendData:[],
      orderDetailData: {},
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    async switchToD803(){
      const h = this.$createElement;
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入SMT工单号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, this.orderDetailData.orderNumber),
          h("span", null, `】以确认切换为【智能穿戴】`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.orderDetailData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
      const res = await apiSwitchToD803({
        id: this.tabPaneValue,
        toNewProductId: '171855420745977850'
      });
      if (res.code == 0) {
        this.orderDetailData = res.data;        
        this.$parent.detailData = res.data;
        await this.getSmtOrderDetail();
        this.$message({
          message: "型号切换成功，可使用【智能穿戴】工序的生产了！",
          type: "success",
        });
      }
      });
    },
    // 订单详情数据
    async getSmtOrderDetail(callback) {
      const res = await apiSmtOrderDetail({
        id: this.tabPaneValue,
      });
      if (res.code === 0) {
        this.orderDetailData = res.data;
        this.$parent.detailData = res.data;
        this.$parent.detailStatus = res.data.status;
        if (callback) callback();
        this.getSmtOrderExtendSearch();
      }
    },
    // 修改工单信息
    async updateSmtOrder() {
      let resCustomer = await apiCustomerList({
      });
      if (resCustomer.code === 0) {
        this.pullDownData.customerList = resCustomer.data;
      }
      let res = await apiProductList({
        productType: "IPC",
      });
      if (res.code === 0) {
        this.pullDownData.productList = res.data;
      }

      this.dialogTitle = "修改工单信息";
      this.$refs.myDialog.dialogVisible = true;
      let {
        product,
        fwVersion,
        customer,
      } = this.orderDetailData;
      this.dialogForm = {
        id: this.tabPaneValue,
        productId:product.id,
        fwVersion,
        customerId: customer.id,
        notes: this.orderDetailData.notes || null,
      };
    },

    // 固件下拉
    async productChange(value) {
      console.log(value);
      // 清空固件选择框内容
      this.dialogForm.fwVersion = '';
      // 清空固件列表
      this.pullDownData.fwList = [];

      let res = await apiFirmwareList({
        customerId: this.dialogForm.customerId,
        productId: value,
        type: "Flash"
      });
      if (res.code === 0) {
        this.pullDownData.fwList = res.data;
      }
    },

    // 对话框提交
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title === "修改工单信息") {
            res = await apiupdateSmtOrder({
              ...this.dialogForm,
              id: this.tabPaneValue,
            });
          }
          else if (title === "新增扩展字段信息") {
            res = await apiAddOrderExtendConfig({
              ...this.dialogForm,
              id:this.tabPaneValue,
              orderId: this.tabPaneValue
            });
          }
          else if (title === "修改扩展字段信息") {
            res = await apiUpdateOrderExtendConfig({
              ...this.dialogForm,
              id: this.tabPaneValue,
              orderId: this.tabPaneValue
            });

          }
          if (res.code === 0) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.$refs.myDialog.dialogVisible = false;
            await this.getSmtOrderDetail();
          }
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 表格数据
    async getSmtOrderExtendSearch(remove, callback) {
      if (!(remove === "noRemove")) {
        this.productionOrderExtendData = [];
      }
      const res = await apiSearchOrderExtendConfig({
        orderId: this.tabPaneValue,
      });
      if (res.code === 0) {
        this.productionOrderExtendData = res.data;
        if (callback) callback();
      }
    },
    // 新增扩展字段信息
    addOrderExtendInfo() {
      this.dialogTitle = "新增扩展字段信息";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改扩展字段信息
    updateOrderExtendInfo(e,row) {
      this.dialogTitle = "修改扩展字段信息";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm={
        fieldName:row.fieldName,
        fieldKey:row.fieldKey,
        fieldValue:row.fieldValue
      }
    },
// 删除扩展字段信息
    deleteOrderExtendInfo(e,row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = "请输入字段名称:【";
      const st = row.fieldKey;
      this.$msgbox({
        title: `提示！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确定删除！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {

        const res = await apiDeleteOrderExtendConfig({
          fieldName:row.fieldName,
          fieldKey:row.fieldKey,
          fieldValue:row.fieldValue,
          id: this.tabPaneValue,
          orderId: this.tabPaneValue
        });
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getSmtOrderExtendSearch();
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
  .pass {
    color: #67C23A;
  }
  .ng {    
    color: #F56C6C;
  }
  .icon-fasong {
    margin-left: 5px;
  }
</style>